<template>
    <div id="passwordResetMailSent">
        <patternlib-headline :headline="$t('passwordResetMailSent.headline')" heading-tag="h2" separator="none" />
        <p style="margin-top: var(--spacing-6);" v-html="$t('passwordResetMailSent.text', {'mail': mail})"></p>
        <patternlib-button 
            style="margin-top: var(--spacing-6);"
            :label="$t('passwordResetMailSent.backToLogin')"
            type="secondary"
            @click="() => {this.$router.push('/')}"
        />
    </div>
</template>

<script>
export default {
    props: ["mail"],

    data: () => ({
    }),

    mounted() {
    }
}

</script>

<style lang="scss" scoped>
#passwordResetMailSent {
    margin: 64px;
}

</style>